// Where to go after a magic-link sign-in. The link always lands on
// /auth/callback (often in a new tab), which used to send everyone to the
// start page, so a link to one lead in an alert email lost the lead (Sam,
// 12 Oct 2026). The sign-in screen remembers the page it was opened on; the
// callback goes back there. Same-site paths only, and only for an hour.

const KEY = 'omni-return-to'
const MAX_AGE_MS = 60 * 60 * 1000

/** Called by the sign-in screen: remember the page it is standing on. */
export function rememberReturnTo(): void {
  try {
    const path = window.location.pathname + window.location.search
    if (path === '/' || path.startsWith('/auth')) return
    localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }))
  } catch {
    /* no storage: the callback just goes to the start page */
  }
}

/** Called by the callback once signed in: the remembered page, used once. */
export function takeReturnTo(): string | null {
  try {
    const raw = localStorage.getItem(KEY)
    localStorage.removeItem(KEY)
    if (!raw) return null
    const { path, at } = JSON.parse(raw) as { path?: unknown; at?: unknown }
    if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//') || path.startsWith('/auth')) return null
    if (typeof at !== 'number' || Date.now() - at > MAX_AGE_MS) return null
    return path
  } catch {
    return null
  }
}
